import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { scaleRowSx, scaleBtnSx } from '../styles';

const ScaleRating = ({
  min = 1,
  max = 10,
  value,
  onChange,
}) => {
  const numbers = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  return (
    <Box sx={scaleRowSx}>
      {numbers.map((num) => (
        <Button
          key={num}
          onClick={() => onChange?.(num)}
          sx={scaleBtnSx(value === num)}
        >
          {num}
        </Button>
      ))}
    </Box>
  );
};

ScaleRating.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
};

export default ScaleRating;
